import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import DropDown from "../common/Dropdown/Dropdown";
import { useDispatch, useSelector } from "react-redux";
import { updateDates, updateTimeframe } from "../../redux/features/clientTransactionSlice";
import { timeframeOptions } from "../../variables/constants";
import { RootState } from "../../redux/store";
import CustomDateRange from "../common/Dialog/CustomDateRange";
import { LoadingButton } from "@mui/lab";
import { DropdownOptions } from "../common/Dropdown/Dropdown";

interface Props {
  showClearFilters?: Boolean;
  clearFilters?: Function;
  accountOptions?: DropdownOptions[];
  account?: string;
  setAccount?: (_val: string) => void;
}

const TableFilters = ({
  showClearFilters = false,
  clearFilters = () => {},
  accountOptions = [],
  account = "0",
  setAccount = () => {},
}: Props) => {
  const { timeframe } = useSelector(
    (state: RootState) => state.clientTransactionsState
  );
  const [timeFrame, setTimeFrame] = useState(timeframe ?? "");
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    dispatch(updateTimeframe(timeFrame));
    timeFrame === "2" && setOpen(true);
  }, [timeFrame]);
  
  const handleClose = () => {
    setOpen(false);
  };

  const handleApplyClose = () => {
    setOpen(false);
    setTimeFrame("0");
    dispatch(updateTimeframe("0"));
  };

  return (
    <Box
      sx={{
        display: "flex",
        padding: "26px 0px 0px 26px",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Typography variant="h5" component="h4">
        Account Activity
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <DropDown
          val={account}
          setVal={setAccount}
          options={accountOptions}
          label="Account"
          width="236px"
          height="36px"
          placeholder="All Accounts"
        />
        <DropDown
          val={timeFrame}
          setVal={setTimeFrame}
          options={timeframeOptions}
          label="Timeframe"
          width="236px"
          height="36px"
        />
        <CustomDateRange
          handleClose={handleClose}
          open={open}
          handleApplyClose={handleApplyClose}
          updateDates={updateDates}
        />
        {showClearFilters ? (
          <LoadingButton
            variant="outlined"
            data-testid="clearFiltersBtn"
            size="small"
            className="export-button"
            onClick={() => clearFilters()}
            sx={{ marginRight: "26px", width: "200px", height: "36px" }}
          >
            {"CLEAR FILTERS"}
          </LoadingButton>
        ) : null}
      </Box>
    </Box>
  );
};

export default TableFilters;
